export const BaseURL = "https://vm2email.azurewebsites.net/api" 